// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- Hs Code
import { ToastModel } from '../../models';
import { Observable, BehaviorSubject } from 'rxjs';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class AppToastService {
  private _toasts: ToastModel[];

  private _toasts$: BehaviorSubject<ToastModel[]>;
  get toasts$(): Observable<ToastModel[]> {
    return this._toasts$;
  }

  toasts: ToastModel[] = [];

  constructor() {
    this._toasts = new Array<ToastModel>();
    this._toasts$ = new BehaviorSubject<ToastModel[]>(this._toasts);
  }

  show(toast: ToastModel) {
    this._toasts = [ ...this._toasts, toast ];
    this._toasts$.next(this._toasts);
  }

  remove(toast: ToastModel) {
    this._toasts = this._toasts.filter(t => t !== toast);
    this._toasts$.next(this._toasts);
  }
}
